import { render, staticRenderFns } from "./SNCRNumeracoesModal.vue?vue&type=template&id=bf93c508&scoped=true&"
import script from "./SNCRNumeracoesModal.vue?vue&type=script&lang=js&"
export * from "./SNCRNumeracoesModal.vue?vue&type=script&lang=js&"
import style0 from "./SNCRNumeracoesModal.vue?vue&type=style&index=0&id=bf93c508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf93c508",
  null
  
)

export default component.exports